import { fetchWithAuth } from './api';
import { ensureOk, okJson } from './httpError';

export interface ASORecord {
  id: string;
  person_id: string;
  customer_id: string;
  aso_type: 'admissional' | 'periodico' | 'retorno' | 'demissional';
  issue_date: string;
  expiry_date: string;
  result: 'apto' | 'inapto' | 'apto_com_restricoes';
  doctor_name?: string;
  doctor_crm?: string;
  notes?: string;
  is_valid: boolean;
  created_at: string;
  updated_at: string;
}

export interface CreateASORequest {
  aso_type: ASORecord['aso_type'];
  issue_date: string;
  expiry_date: string;
  result: ASORecord['result'];
  doctor_name?: string;
  doctor_crm?: string;
  notes?: string;
}

export type UpdateASORequest = Partial<CreateASORequest>;

const BASE = (customerId: string, personId: string) =>
  `/api/v1/customers/${customerId}/people/${personId}/aso-records`;

export const asoService = {
  list: async (customerId: string, personId: string): Promise<ASORecord[]> => {
    const res = await fetchWithAuth(BASE(customerId, personId));
    // Unchecked, an error body hit `?? []` and reported "no ASO records" — which, with
    // aso_block_access enabled, is a materially different statement from "could not load".
    const data = await okJson<any>(res, 'Erro ao carregar os ASOs');
    return data.aso_records ?? [];
  },

  create: async (
    customerId: string,
    personId: string,
    req: CreateASORequest
  ): Promise<ASORecord> => {
    const res = await fetchWithAuth(BASE(customerId, personId), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(req),
    });
    await ensureOk(res, 'Erro ao criar registro ASO');
    const data = await res.json();
    return data.aso_record;
  },

  update: async (
    customerId: string,
    personId: string,
    asoId: string,
    req: UpdateASORequest
  ): Promise<ASORecord> => {
    const res = await fetchWithAuth(`${BASE(customerId, personId)}/${asoId}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(req),
    });
    await ensureOk(res, 'Erro ao atualizar registro ASO');
    const data = await res.json();
    return data.aso_record;
  },

  delete: async (customerId: string, personId: string, asoId: string): Promise<void> => {
    const res = await fetchWithAuth(`${BASE(customerId, personId)}/${asoId}`, {
      method: 'DELETE',
    });
    await ensureOk(res, 'Erro ao excluir registro ASO');
  },
};
